import { render, staticRenderFns } from "./scrapping.vue?vue&type=template&id=6173f66c&scoped=true"
import script from "./scrapping.vue?vue&type=script&lang=js"
export * from "./scrapping.vue?vue&type=script&lang=js"
import style0 from "./scrapping.vue?vue&type=style&index=0&id=6173f66c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6173f66c",
  null
  
)

export default component.exports